module.exports = __webpack_public_path__ + "media/images/common/menu_bag-93ea6cce4cb7d07abdb376fe265451f8.gif";